import React, { useState, useEffect } from "react";
import history from "../../utilities/history";
import { Link } from "react-router-dom";
import MicrosoftLogin from "react-microsoft-login";
import { MsalAuthProvider, LoginType } from "react-aad-msal";
import { AzureAD } from "react-aad-msal";
import { Redirect } from "react-router-dom";
import Logo from "../../images/Logo.png";
import ResetPasswordComponent from "./ResetPasswordComponent";
import ResetPassword from "../../containers/Login/ResetPassword";
import { EMAILREGEX,MODAL_SIZE } from "../../App.config";
import validation from "../../utilities/validation";
import * as utilities from "../../utilities/utils";
import VerifyUserOtpComponent from "../../containers/VerifyUserOtp"

const authHandler = (err, data) => {
  if (data) {
    if (
      data.authResponseWithAccessToken &&
      data.authResponseWithAccessToken.accessToken
    ) {
      history.push("/dashboard");
    }
  }
};

// const config = {
//   auth: {
//     authority: 'https://login.microsoftonline.com/',
//     clientId: '763ef029-4735-40e4-94a1-328dd9d42ef8',
//     redirectUri: 'http://localhost:3000/#/STD'
//   },
//   cache: {
//     cacheLocation: "localStorage",
//     storeAuthStateInCookie: true
//   }
// };

// Authentication Parameters
const authenticationParameters = {
  scopes: [
    "<property (i.e. user.read)>",
    "https://Vertex329.onmicrosoft.com/JainamADDrive1/",
  ],
};
// Options
const options = {
  loginType: LoginType.Popup,
  tokenRefreshUri: window.location.origin + "/auth.html",
};

const Login = (props) => {
  const initialState = {
    email: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: EMAILREGEX,
      },
    },
    password: {
      value: "",
      error: "",
      validation: {
        required: true,
      },
    },
    isSubmitOnce: { value: false },
  };

  // useEffect(()=>{
  //     if(props.isPasswordExpired){
  //       props.openSetModalAction(<PasswordExpireComponent email={state.email.value}/>,MODAL_SIZE.MODAL_SM);
  //       props.resetIsPasswordExpired(false);
  //       // history.push("/setExpiryPassword");
  //     }
  // },[props.isPasswordExpired]);

  
 
  useEffect(()=>{
      if(props.loginReducer.isLogin){
        props.openSetModalAction(<VerifyUserOtpComponent 
          // email={state.email.value}
          {...props}
          />,MODAL_SIZE.MODAL_SM);
        props.resetIsPasswordExpired(false);
        // history.push("/setExpiryPassword");
        props.isLoginSuccessfull(false);
      }
  },[props.loginReducer.isLogin]);

  const [state, setState] = useState(initialState);

  const handleChanges = (event) => {
    let { name, value, checked, type } = event.target;
    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }

    setState((state) => {
      return {
        ...state,
        [name]: updatedObj,
      };
    });
  };

  const FormValidation = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        let validatedObj = validation(state[property]);

        setState((state) => {
          return {
            ...state,
            [property]: validatedObj,
          };
        });
      }
    }
  };

  const isFormValid = () => {
    let isValid = true;
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        if (state[property]?.error.length > 0) {
          isValid = false;
        }
      }
    }
    return isValid;
  };

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setState((state) => {
      return {
        ...state,
        isSubmitOnce: utilities.convertIntoObject(true),
      };
    });

    FormValidation();

    if (isFormValid()) {
      props.varifyLogin({
        emailid: state.email.value,
        password: state.password.value,
      });
    }
  };
  const onResetPassword = () => {
    props.openSetModalAction(<ResetPassword/>,MODAL_SIZE.MODAL_SM);
  };

  return (
    <>
      {/* {props.isAuthenticating ? (
        <div className="login-alert">
          <div className="alert alert-success" role="alert">
            Authenticating...
          </div>
        </div>
      ) : null}
      {props.isAuthenticated ? (
        <div className="login-alert">
          <div className="alert alert-success" role="alert">
            Authentication Successfully...
          </div>
        </div>
      ) : null} */}
      {props.isAuthenticationFailed ? (
        <div className="login-alert">
          <div className="alert alert-danger" role="alert">
            Authentication Failed. / Échec de l’authentification.
          </div>
        </div>
      ) : null}
      {props.isSessionValid ? (
        <div className="login-alert">
          <div className="alert alert-danger" role="alert">
            Session Expired
          </div>
        </div>
      ) : null}

      <div className="Login-panel">
        <div className="Outer-cell">
          <div className="Inner-cell">
            <div className="Logo-panel">
              <img src={Logo} alt="" />
            </div>
            <form>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Email Address / Adresse courriel</label>
                <input
                  type="email"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="Email Address / Adresse courriel"
                  name="email"
                  value={state.email.value}
                  onChange={handleChanges}
                  onKeyDown={handleKeyDown}
                />
                {state.email?.error && (
                  <span className="error">{state.email.error}</span>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputPassword1">Password / Mot de passe</label>
                <input
                  type="password"
                  name="password"
                  className="form-control"
                  id="exampleInputPassword1"
                  placeholder="Password / Mot de passe"
                  value={state.password.value}
                  onChange={handleChanges}
                />
                {state.password?.error && (
                  <span className="error">{state.password.error}</span>
                )}
              </div>

              <button
                onClick={onSubmit}
                type="submit"
                className="btn btn-primary"
              >
                Login / Connexion
              </button>

              <div className="login-microsoft-btn">
                <MicrosoftLogin
                  redirectUri={"https://192.168.32.37:441/#/dashboard"}
                  clientId={"763ef029-4735-40e4-94a1-328dd9d42ef8"}
                  tenantId={"7228433f-7292-48b0-abb7-cf2abb56c526"}
                  authCallback={authHandler}
                />
              </div>
              <div className="reset-pass">
                <a className="reset-pass" onClick={onResetPassword}>
                  Reset Password / Modifier le mot de passe
                </a>
              </div>
              {/* 
            <AzureAD provider={authProvider} forceLogin={true}>
              <App />
            </AzureAD> */}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
// export const authProvider = new MsalAuthProvider(config, authenticationParameters, options)
export default Login;
